/*
 *      plainCSS()
 *      returns the css value without using hooks
 */
(function( $ ) {
    $.fn.plainCSS = function( name ) {
        'use strict';

        // turn of hooks
        var _hooks  = $.cssHooks;
        $.cssHooks  = {};

        var result  = this.css( name );

        //revert hooks
        $.cssHooks  = _hooks;

        return result;
    };
})(jQuery);
